import { createSharedApp } from '@/shared/baseApp';
import login from './components/login.vue';
import profile from './components/profile/my/index.vue';
import apiClients from './components/profile/apiClients/overview.vue';
import accessDenied from './components/profile/accessDenied.vue';
import forgotPassword from './components/profile/forgotPassword.vue';
import resetPassword from './components/profile/resetPassword.vue';
import register from './components/profile/register.vue';
import logout from './components/profile/logout.vue';
import App from './App.vue';

const routes = [
    {name: 'Root', path: '/', redirect: '/login'},
    {name: 'Login', path: '/login', component: login},
    {name: 'LoginEnTab', path: '/LoginEnTab', component: login},
    {name: 'Profile', path: '/profile', component: profile},
    {name: 'ApiClients', path: '/profile/apiClients', component: apiClients},
    {name: 'AccessDenied', path: '/profile/accessDenied', component: accessDenied},
    {name: 'Logout', path: '/profile/logout', component: logout},
    {name: 'LogoutEnTab', path: '/profile/LogoutEnTab', component: logout},
    {name: 'ForgotPassword', path: '/profile/forgotPassword', component: forgotPassword},
    {name: 'ResetPassword', path: '/profile/resetPassword', component: resetPassword},
    {name: 'Register', path: '/profile/register', component: register},
    {name: 'NotFound', path: '/:pathMatch(.*)*', redirect: '/login'},
];

const app = createSharedApp(App, routes, 'Account');
app.mount("#app");